import { utcDate, UTCDate } from '../time-utils.service';


// export interface LayerTimePeriod {
//   timeperiod?: number[];
// }

export interface TimeInterval {
  days?: number;
  months?: number;
  years?: number;
}

export interface TimeStep {
  timestep: "daily" | "monthly"  | "yearly";
  timestepMultiplier?: number;
}

const MAXIMUM_DATE_SHIFT=60;

export class DateRange {
  start: UTCDate;
  end: UTCDate;
  format: string;
  interval?: TimeInterval;

  static dateFromConfig(json: any, end?: boolean): UTCDate {
    if (!json) {
      return null;
    }

    if ('number' === typeof json) {
      if (json < MAXIMUM_DATE_SHIFT) {
        let d = new Date();
        d.setUTCDate(d.getUTCDate() + json);
        return d;
      }
      if (end) {
        return utcDate(json, 11, 31);
      }

      return utcDate(json, 0, 1);
    }

    // ? expect a string and parse out dd/mm/yyyy?
    var [yyyy, mm, dd] = (json as string).split('/').map(elem => +elem);
    return new Date(yyyy, mm - 1, dd);
  }

  static fromJSON(json: any): DateRange {
    var result = new DateRange();

    if(json){
      result.start = DateRange.dateFromConfig(json.start);
      result.end = DateRange.dateFromConfig(json.end, true);
      result.format = json.format || result.format;
      result.interval = json.interval || result.interval;
    }

    return result;
  }

  containsYear(yr: number): boolean {
    //TODO Deprecated
    return (yr >= this.start.getUTCFullYear()) &&
      (yr <= this.end.getUTCFullYear());
  }

  contains(d:UTCDate):boolean{
    return this.afterStart(d) && this.beforeEnd(d);

    //TODO Deprecated
    // let yr = d.getUTCFullYear();

    // if((yr<this.start.getUTCFullYear())||
    //    (yr>this.end.getUTCFullYear())){
    //   return false;
    // }

    // if(yr<this.end.getUTCFullYear()){
    //   return true;
    // }
    // return d<=this.end;
  }

  beforeEnd(d:UTCDate):boolean{
    return !this.end||(d<=this.end);
  }

  afterStart(d:UTCDate):boolean{
    return !this.start||(d>=this.start);
  }
}

export function identifyTimestep(dates: UTCDate[]): TimeStep {
  // attempt to detect/infer the timestep from a list of dates
  const dateObjects = dates;

  // Calculate differences between consecutive dates
  const dailyDifferences = new Set<number>();
  for (let i = 0; i < dateObjects.length - 1; i++) {
      let diff = (dateObjects[i + 1].getTime() - dateObjects[i].getTime()) / (1000 * 60 * 60 * 24);
      diff = Math.round(diff);
      if(diff===0){
        continue;
      }
      dailyDifferences.add(diff);
  }

  // Map the difference to a timestep
  if (dailyDifferences.size === 1 && dailyDifferences.has(1)) {
      return {timestep:"daily"};
  }

  if (dailyDifferences.size === 1 && dailyDifferences.has(7)) {
      return {timestep:"daily", timestepMultiplier:7};
  }

  const daysOfMonths = new Set<number>(dateObjects.map(date => date.getUTCDate()));
  if (daysOfMonths.size > 1) {
      return null;
  }

  const minDiff = Math.min(...Array.from(dailyDifferences));
  const maxDiff = Math.max(...Array.from(dailyDifferences));
  if (minDiff >= 28 && maxDiff <= 31) {
      return {timestep:"monthly"};
  }
  if (minDiff >= 90 && maxDiff <= 92) {
      return {timestep:"monthly", timestepMultiplier:3};
  }

  const monthsOfYear = new Set<number>(dateObjects.map(date => date.getUTCMonth()));
  if (monthsOfYear.size > 1) {
      return null;
  }

  if (minDiff >= 365 && maxDiff <= 366) {
      return {timestep:"yearly"};
  }

  return null;
}
